import(/* webpackMode: "eager" */ "/app/packages/frontend/app/error.tsx");
